import { useEffect, useState } from "react";
import { Text } from "react-native";
import { colors } from "./colors";

/** "14:59": the hold's time left, never below zero. */
export function heldForLabel(expiresAt: string, now: number) {
  const seconds = Math.max(
    0,
    Math.floor((Date.parse(expiresAt) - now) / 1000),
  );
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}

/** "Held for 14:59", ticking every second, as the tickets sheet shows it. */
export function HeldFor({ until }: { until: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  return (
    <Text
      accessibilityLabel={`Tickets held for ${heldForLabel(until, now)}`}
      style={{
        color: colors.secondary,
        fontSize: 13,
        fontVariant: ["tabular-nums"],
      }}
    >
      Held for {heldForLabel(until, now)}
    </Text>
  );
}
